import { ThemeConfig } from 'antd';
import { DefaultTheme } from 'styled-components';
import { singleton } from 'tsyringe';
import { antDesignComponentTokens, antDesignToken } from '../../../config/theme/appTheme/appTheme';
import { kccComponentTokens, kccToken } from 'config/theme/kccTheme/kccTheme';
import { styledComponentTheme } from 'config/theme/styledComponentTheme';

@singleton()
export class Styling {
  public getStyledComponentsTheme = (): DefaultTheme => styledComponentTheme;

  public getAntDesignThemeConfig = (): ThemeConfig => ({
    token: antDesignToken,
    components: antDesignComponentTokens,
  });

  public getAntDesignKCCThemeConfig = (): ThemeConfig => ({
    token: kccToken,
    components: kccComponentTokens,
  });
}
